<template>
  <div class="unitBoardInformation">
    <box></box>
    <el-card shadow="never">
      <el-form :inline="true" ref="searchForm" class="search-form">
        <el-form-item>
          <span class="queryInfo">{{ $t('recentQuery') }}  {{ updateTime }}</span>
        </el-form-item>
        <el-form-item style="float: right">
          <el-button style="width: 90px" type="primary" :loading="searching" @click="_getBoard">{{$t('queryButton')}}</el-button>
        </el-form-item>
      </el-form>
      <el-table ref="basePageTable" :data="rows" :height="offsetWindowHeight" v-loading="searching">
        <el-table-column type="index" :label="$t('number')" :index="indexMethod" align="center"></el-table-column>
        <el-table-column prop="boardType" :label="$t('boardType')" align="center"></el-table-column>
        <el-table-column prop="boardNo" :label="$t('boardNumber')" align="center"></el-table-column>
        <el-table-column prop="boardPsn" :label="$t('panelPSN')" align="center" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="version" :label="$t('version')" align="center" show-overflow-tooltip>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import BasePage from "@/components/BasePage";
import Status from "components/Status";
import Box from "@/components/Box";
// eslint-disable-next-line no-unused-vars
import {stampToDateTime, formatDate} from "assets/utils"
import {getBoard} from "@/api/query"
import {mapState} from "vuex";
export default {
  name: "unitBoardInformation",
  mixins: [BasePage, Status],
  components: {
    Box
  },
  data() {
    return {
      updateTime: ''
    }
  },
  computed: {
    ...mapState({
      boardTypeOptions: state => state.boardTypeOptions
    }),
    controllInfo() {
      return this.$store.state.controlInfo
    }
  },
  methods: {
    getRows() {
      // this._getBoard()
    },
    _getBoard() {
      let _this = this
      this.searching = true
      this.show()
      this.updateTime = formatDate(new Date())
      getBoard({controllerPsn: this.controllInfo.controllerPsn}).then((res) => {
        res.data.forEach((item) => {
          item.boardType = _this.boardTypeOptions.find(v => v.code === item.boardType).name
        })
        this.rows = res.data
        this.searching = false
        this.success(res.message ? res.message : '操作成功')
      }).catch(() => {
        this.failed()
        this.searching = false
      })
    },
    go_detail(item) {
      this.isShow = true
      /* this.$router.push({ path: '/management/commission/detail', query: { loginName: item.loginName } }) */
    }
  }
}
</script>

<style lang="scss" scoped>
.unitBoardInformation{
  width: 100%;
  height: 100%;
  .search-form{
    .queryInfo{
      padding: 0 10px;
      color: #B3BBC1;
      font-size: 12px;
    }
  }
}
</style>
